import React from 'react';
import createSVG from './createSVG';

const SettingsIcon = ({style}) => (
   <path style={style} d="M25 3.788H1M25 21.97H1m24-9.091H1m15.242 6.0603V25m3.88-24v6.0605M9.0028 9.8717v6.0604" stroke="#7D7D7D" strokeWidth="1.71" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round"/>
);

export default createSVG(SettingsIcon);
